import * as actionTypes from "./types";

/* Whiteboard Actions */
// export const setShowWhiteboard = value => {
//   return {
//     type: actionTypes.SET_SHOW_WHITEBOARD,
//     payload: {
//       showWhiteboard: value
//     }
//   }
// }

export const saveWhiteboardLayers = value => {
  return {
    type: actionTypes.SAVE_WHITEBOARD_LAYERS,
    payload: {
      layers: value
    }
  }
}

export const saveWhiteboardBackground = value => {
  return {
    type: actionTypes.SAVE_WHITEBOARD_BACKGROUND,
    payload: {
      background: value
    }
  }
}